export const lang = {
    header_index: '首页',
    header_about: '我们',
    header_project: '投资项目',
    header_friend: '战略合作',
    header_people: '人力资源',
    header_news: '新闻',
    header_memo: '创始人',
    header_lang: 'English',

    //底部
    foot_Phone: '联系电话：021-55785999',
    foot_Mailbox: '邮箱：info@modern-cap.com',
    foot_Address: '地址：上海市浦东新区浦东大道1200号巨洋大厦16楼S09',


    //主页
    index_Company_wx: '微信二维码',
    index_Company_Profile: '公司简介',
    index_Company_Profile_text: "马笛儿投资成立于2016年，是一家专注于移动互联网+、跨境娱乐/消费和智能硬件/物联网等领域的公司，在以微信为代表的新传播和营销渠道上项目投资业绩处于领先地位，10余个马笛儿投资的项目受到腾讯著名投资机构后续投资。公司在2017年和2018年获得腾讯“优秀投资伙伴”奖项，并与腾讯签署了战略合作协议。团队具有国际视野和丰富的跨境交易经验，从零开始在韩国投资7个项目，成为在韩国最成功的中国投资团队，并在日本设立办公室，展开跨境消费品行业并购。",

    //人力资源页面
    people_title: '人力资源服务',
    people_text: '马笛儿投资集结了顶尖互联网创投和传统高端猎头双重基因，与领先的创业团队进行360°人才战略合作。服务范围包含：高端人才招聘、公司组织架构设计、期权和其它激励设计、社保⼈资咨询和项目服务等。',

    //创始人寄语
    ceo_info_name: '许捷',
    ceo_info_nick: '创始人、首席服务生',
    ceo_info_title: '马笛儿投资，做创业者身边的创业者',
    ceo_info_text1: '回归学习和研究的本位，支持创业者试错并做出重要创新，是创业投资者的应有之义。把握消费者需求本身和需求实现方式的变化升级，参与这两大变化升级相关的伟大企业，回报信任我们的投资人，是我们主要的工作目标。',
    ceo_info_text2: '我们团队的成员在过去十年完成了一些激动人心的投资和退出，取得了一些回报，但更重要的是获得了很多经验和教训。展望未来，我们将加倍重视研究基因和整体资源整合能力，重点在面对消费者的业务布局，取得更好、更重要的成果。',
    ceo_info_text3: '我们在泛消费者领域特别是以微信为代表的新渠道上的投资业绩，位于全行业领先地位。',
    ceo_info_text4: '一直以来跨国的投资并购，特别是消费品和文化领域的投资并购始终是我们擅长的领域。此外，医疗服务和生物制药相关是我们不太擅长，但是长远非常看好的领域，我们正在迎头赶上。',

    //投资项目
    project_info_title: '投资项目介绍',
    project_info_btn1: '国内项目',
    project_info_btn2: '境外项目',

    //合作
    fried_one: "战略合作伙伴",
    fried_two: '投资人'
}